import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { DataService } from '@/services/data.service';
import { TokenIdParsePipe } from '@/pipes/token-id-parse.pipe';
import { TippyDirective } from '@/directives/tippy.directive';
import { environment } from 'src/environments/environment';
import { cloneBidConfirmLabel } from '@/utils/native-market-bid-labels';

@Component({
  selector: 'app-bid-copy-confirmation-modal',
  standalone: true,
  imports: [
    CommonModule,
    LazyLoadImageModule,
    TokenIdParsePipe,
    TippyDirective
  ],
  templateUrl: './bid-copy-confirmation-modal.component.html',
  styleUrls: ['./bid-copy-confirmation-modal.component.scss']
})
export class BidCopyConfirmationModalComponent implements OnChanges, AfterViewChecked {
  readonly cloneBidConfirmLabel = cloneBidConfirmLabel;
  @Input() isActive: boolean = false;
  @Input() punkIds: number[] = [];
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  @ViewChild('punksScrollContainer') punksScrollContainer!: ElementRef<HTMLDivElement>;

  hasScrolledToBottom: boolean = false;
  protected readonly environment = environment;
  private needsScrollCheck = false;

  constructor(public dataSvc: DataService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isActive']) {
      if (changes['isActive'].currentValue) {
        this.hasScrolledToBottom = false;
        this.needsScrollCheck = true;
      }
    }
  }

  ngAfterViewChecked(): void {
    if (this.needsScrollCheck && this.punksScrollContainer) {
      this.needsScrollCheck = false;
      this.checkIfScrollNeeded();
    }
  }

  onScroll(): void {
    if (this.hasScrolledToBottom) return;
    const el = this.punksScrollContainer?.nativeElement;
    if (!el) return;
    const threshold = 20;
    if (el.scrollHeight - el.scrollTop - el.clientHeight <= threshold) {
      this.hasScrolledToBottom = true;
    }
  }

  onConfirm(): void {
    if (!this.hasScrolledToBottom) return;
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  private checkIfScrollNeeded(): void {
    const el = this.punksScrollContainer?.nativeElement;
    if (!el) return;
    if (el.scrollHeight <= el.clientHeight) {
      this.hasScrolledToBottom = true;
    }
  }
}
